<template>
  <!-- Dashboard Layout -->
  <div>
      <slot />
    <!-- <NotificationList /> -->
  </div>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>